<template>
  <div class="sky-date-picker">
    <sky-suffix v-bind="$attrs">
      <component
        v-if="prepend"
        slot="prepend"
        v-bind="prepend"
        :is="prepend.type"
        v-model="select"
        @change="handleChange"
      ></component>
      <el-date-picker
        v-model="timeValue"
        :type="type"
        :value="selfData"
        @change="change"
        v-bind="$attrs"
        :value-format="valueFormat"
        :unlink-panels="true"
        :placeholder="placeholder"
        :picker-options="pickerOptions"
      >
      </el-date-picker>
    </sky-suffix>
  </div>
</template>
<script>
import SkySuffix from "../formComponents/SkySuffix.vue";
// import formStore from "@/mixins/formStore.js";
export default {
  name: "sky-date-picker-prepend",
  props: {
    value: [String, Number, Array, Object],
    placeholder: [String, Number],
    pickerOptions: Object,
    valueFormat: {
      default: "yyyy-MM-dd"
    },
    type: {
      default: "date"
    },
    prepend: Object
  },
  // mixins: [formStore],
  inheritAttrs: false,
  components: {
    SkySuffix
  },
  data() {
    return {
      timeValue: [],
      select: this.value[2],
      selfData: ""
    };
  },
  methods: {
    setVal() {
      this.$emit("input", this.timeValue);
    },
    getVal() {
      this.timeValue = this.value;
    },
    change (val) {
      this.timeValue = val || ['', ''];
      this.selfData = [...this.timeValue, this.select];
      !this.delay && this.$emit("input", this.selfData);
    },
    handleChange(val) {
      this.select = val;
      this.selfData = [...this.timeValue, this.select];
      this.$emit("input", this.selfData);
    }
  },
  watch: {
    value: {
      handler: function(val) {
        if (val) {
          this.timeValue = [val[0], val[1]];
          this.select = val[2];
        } else {
          this.timeValue = [];
          this.select = "";
        }
      },
      immediate: true
    }
  },
  computed: {},
  created() {}
};
</script>
<style scoped lang="scss">
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.el-date-editor {
  position: relative;
  left: -2px; 
}
</style>
